export default __webpack_public_path__ + "static/media/icon-sort.72badfbb.svg";